import type { TabsDefinition } from '@/src/experiences/tabs'
import { RewardsIcons } from '../icons'

export const RewardsTab = {
  rewards: {
    name: 'rewards',
    title: 'Rewards',
    Icon: RewardsIcons.RewardsOutlined,
    href: `/main/(tabs)/rewards`,
    options: {
      tabBarButton: () => null,
      tabBarItemStyle: {
        position: 'absolute',
        width: 0,
        height: 0,
        left: -1000,
      },
    },
  },
} as const satisfies TabsDefinition
